import { Chip } from "@mui/material"
import { If } from "lib/@components/switch"

export function DisabledChip({ enabled }) {
    return (
        <If value={!enabled}>
            <Chip
                data-cy="rules-panel-rule-disabled"
                label="Disabled"
                size="small"
                variant="outlined"
                sx={{ height: 20, fontSize: 11, fontWeight: 600 }}
            />
        </If>
    )
}
